import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Section from '@/components/base/Section'
import SolidCard, { SolidCardProps } from '@/components/base/SolidCard'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'

export type SolidCardsProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    cards: SolidCardProps[]
  }>

const SolidCards = ({
  title,
  title_variant,
  title_component,
  cards = [],
  className,
  ...props
}: SolidCardsProps) => {
  return (
    <Section className={cn([className])} {...props}>
      <Container>
        <Grid className="gap-y-gutter">
          {title ? (
            <div className="col-span-4 md:col-span-6 lg:col-span-12">
              <Typography
                variant={title_variant}
                component={title_component}
                className="text-heading"
              >
                {title}
              </Typography>
            </div>
          ) : null}

          {cards?.map((card, index) => (
            <div
              key={`push-card-${index}`}
              className={cn([
                'col-span-4 md:col-span-3 lg:col-span-4',
                'lg:group-[.modal]:col-span-6'
              ])}
            >
              <SolidCard {...card} />
            </div>
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default SolidCards
